import { useLocation } from "react-router-dom";
import { UIButton, UITypography } from "../../../_app/components";
import { createStylesheet } from "../../../_app/utils/styles";
import { usePoweredByLogo } from "../../../brand/hooks";
import { useHasAnyFeatureEnabled } from "../../../feature/hooks";
import { Feature } from "../../../feature/types";

const AuthFooter = () => {
  const classes = useStyles();
  const location = useLocation();
  const poweredByLogo = usePoweredByLogo();
  const hasRegister = useHasAnyFeatureEnabled(Feature.RegisterUser) && location.pathname === "/login";

  if (!hasRegister && !poweredByLogo) return null;

  return (
    <div className={classes.footer}>
      {hasRegister && (
        <div className={classes.registerCtr}>
          <UITypography variant="body2" className={classes.registerText}>
            Not registered yet?
          </UITypography>
          <UIButton variant="text" to="/register">
            Register Now
          </UIButton>
        </div>
      )}
      {Boolean(poweredByLogo) && (
        <div className={classes.poweredByCtr}>
          <img alt="powered-by-logo" src={poweredByLogo} />
        </div>
      )}
    </div>
  );
};

const useStyles = createStylesheet((theme) => ({
  footer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: 100,
  },
  poweredByCtr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    height: 140,
    "& > img": {
      display: "block",
      height: 60,
      objectFit: "contain",
    },
  },
  registerCtr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingBottom: theme.spacing(5),
  },
  registerText: {
    paddingTop: theme.spacing(1),
  },
}));

export default AuthFooter;
